export default __webpack_public_path__ + "static/media/vine.27449996.m4a";